<template>
  <IQOS required :title="'Marketplace QR'">
    <div class="qrcode-wrapper mt-16">
      <img src="/icons/app-qrcode.png" class="iqos-qrcode-image" />
      <div class="app-desc">
        <p class="comment pt-0 c-gray">
          {{ $t('marketplace.app_desc') }}
        </p>
        <div class="img-container mt-8">
          <a  target="_blank" href="https://apps.apple.com/ua/app/qrdelivery/id1507792224?l=uk">
            <img src="/icons/app-store.png" alt="" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.webqrdelivery.qrdelivery"
            target="_blank"
          >
            <img src="/icons/google-play.png" alt="" />
          </a>
        </div>
      </div>
    </div>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";

export default {
  components: {
    IQOS,
  },
};
</script>

<style>
.qrcode-wrapper {
  display: flex;
}

.app-desc {
  margin-left: 2.3vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.iqos-qrcode-image {
  width: 160px;
  height: 160px;
  max-width: 160px;
  max-height: 160px;
  min-width: 160px;
  min-height: 160px;
}

.img-container {
  display: flex;
}

.img-container a {
  margin-right: 0.5vh;
}

.img-container img {
  /* width: 14.8vh; */
  width: 20vh;
  height: auto;
}
</style>